import React from 'react';
import { useTranslation } from 'react-i18next';

import './Partner.scss';

import SectionTitle from '../../components/SectionTitle/SectionTitle';
import IconList from '../../components/IconList/IconList';

import PartnerData from './PartnerData';

const Partner = () => {
    const { t } = useTranslation();

    return (
        <section
            className="section-bg section-common features-section pt-100 pb-70"
            data-aos="fade-up"
            data-aos-duration="2000"
        >
            <div className="container">

                <SectionTitle
                    subTitle={t('partners.subTitle')}
                    title={t('partners.title')}
                    description={t('partners.description')}
                />

                <div className="row align-items-center">

                    {PartnerData.map((singleFeature) => (
                        <IconList
                            key={singleFeature.key}
                            icon={singleFeature.icon}
                            title={t(
                                `partners.items.${singleFeature.key}.title`
                            )}
                            description={t(
                                `partners.items.${singleFeature.key}.description`
                            )}
                        />
                    ))}

                </div>

            </div>
        </section>
    );
};

export default Partner;